<ws-modal-wrapper headerLabel="Set Document Retrieval Status"
                  acceptLabel="Save"
                  bodyClass="retrieval-status"
                  [disableSave]="followUpChoice === followUpChoices.DATE && !selectedDate"
                  (save)="submit()"
                  (cancel)="closeModal()">
    <form class="form-horizontal">
        <div class="mb-3 row">
            <label class="col-md-3 control-label">Retrieval Status:</label>
            <div class="col-md-9">
                <select
                    class="form-select form-select-sm"
                    name="retrievalStatusId"
                    [(ngModel)]="retrievalStatusPayload.retrievalStatusId"
                    (change)="recreateComment()">
                    @for (option of retrievalStatuses; track option) {
                        <option [ngValue]="option.retrievalStatusId">{{ option.name }}</option>
                    }
                </select>
            </div>
        </div>
        <div class="mb-3 row">
            <label class="col-md-3 control-label" style="padding-top: 10px;">Follow Up:</label>
            <div class="col-md-9">
                <div class="radio">
                    <label>
                        <input
                            type="radio"
                            [(ngModel)]="followUpChoice"
                            [value]="followUpChoices.DAYS"
                            name="followUps"
                            style="margin-top: 9px;"
                            (change)="recreateComment()"
                        >
                        <div style="display: inline-block; vertical-align: middle;">
                            In
                        </div>
                        <select class="form-select form-select-sm" style="display: inline-block; width: auto; margin: 0 10px;" (change)="setComputedDataFromSelect($event.target); recreateComment()" [disabled]="followUpChoice !== followUpChoices.DAYS">
                            @for (option of daysOptions; track option) {
                                <option [value]="option">{{ option }}</option>
                            }
                        </select>
                        weekdays which is
                        <weissman-datetime [(inputDate)]="computedDate" [dateOnly]="true" [readOnly]="true"></weissman-datetime>
                    </label>
                </div>
                <div class="radio">
                    <label>
                        <input type="radio" [(ngModel)]="followUpChoice" [value]="followUpChoices.DATE" name="followUps" style="margin-top: 9px;" (change)="recreateComment()">
                        <div style="display: inline-block; vertical-align: middle;">
                            On
                        </div>
                        <div style="width: 136px; display: inline-block; vertical-align: middle; margin: 0 5px;">
                            <weissman-datetime [(inputDate)]="selectedDate" [dateOnly]="true" [isDisabled]="followUpChoice !== followUpChoices.DATE" (change)="recreateComment()"></weissman-datetime>
                        </div>
                    </label>
                </div>
                <div class="radio">
                    <label>
                        <input type="radio" [(ngModel)]="followUpChoice" [value]="followUpChoices.NO_FOLLOWUP" name="followUps" (change)="recreateComment()">
                        No Follow Up
                    </label>
                </div>
                <div class="radio">
                    <label>
                        <input type="radio" [(ngModel)]="followUpChoice" [value]="followUpChoices.NO_CHANGE" name="followUps" (change)="recreateComment()">
                        No Change
                    </label>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label class="col-md-3 control-label">Re-Assign To:</label>
            <div class="col-md-9">
                <user-team-picker
                    [user]="retrievalStatusPayload.newAssignment"
                    (userChange)="setUser($event); recreateComment()"
                    [entityIdScope]="instanceId"
                    [entityTypeScope]="'Instance'">
                </user-team-picker>
            </div>
        </div>
        <div class="mb-3 row">
            <label class="col-md-3 control-label">Comment:</label>
            <div class="col-md-9">
                <textarea name="comment" [(ngModel)]="retrievalStatusPayload.comment" class="form-control" rows="5"></textarea>
            </div>
        </div>
        <!-- <div class="mb-3">
        <div class="offset-sm-3 col-md-9">
          <button type="submit" class="btn btn-secondary">Sign in</button>
        </div>
      </div> -->
    </form>
</ws-modal-wrapper>
